// Shared between clientNavigation.global.ts (which sets/restores it) and
// requireTicketMiddleware.ts (which clears it on rejection to avoid a redirect loop).
export const LAST_EVENT_ROUTE_ID = 'wad-last-event-id';
